<template>
    <div>
        <public-title showBack>推送记录</public-title>
        <div class="bg-white box-shadow p-3">
            <el-row>
                <el-col :span="20" class="text-left">
                    <span class="demonstration pr-2">时间范围</span>
                    <el-date-picker
                        v-model="timelimits"
                        type="daterange"
                        size="small"
                        class="ml-3"
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期" />
                </el-col>
                <el-col :span="4" class="text-right">
                    <el-button type="primary" size="small" @click="getRecords">搜索</el-button>
                </el-col>
            </el-row>
            <p v-if="list.length == 0">当前没有数据</p>
            <div v-else>
                <ul class="list-head mt-3"><li class="w-50" v-for="item in titleArr" :key="item">{{item}}</li></ul>
                <ul class="list-item" v-for="(item, index) in list" :key="index">
                    <li class="w-50 list-item-col">{{item.push_time  | formatTimestamp(1)}}</li>
                    <li class="w-50 list-item-col">{{item.store_title}}</li>
                    <li class="w-50 list-item-col" :class="item.is_push_travel == '1' ? 'text-blue' : 'text-danger cursor-pointer'" @click="push('travel', item.is_push_travel, item.room_state_id)">{{item.is_push_travel == '1' ? '已推送' : '未推送'}}</li>
                    <li class="w-50 list-item-col" :class="item.is_push_hotel == '1' ? 'text-blue' : 'text-danger cursor-pointer'" @click="push('hotel', item.is_push_hotel, item.room_state_id)">{{item.is_push_hotel == '1' ? '已推送' : '未推送'}}</li>
                </ul>
            </div>
            <el-pagination background layout="prev, pager, next" class="mt-4"
                        v-if="list.length > 0" :page-size="10"
                         :total="total" :current-page=page
                         @current-change="v => {this.page=v;this.getRecords()}"/>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PushRecord',
    data () {
        return {
            titleArr:['日期时间','酒店名称','采购商推送状态','酒店推送状态'],
            list: [],
            timelimits: '',
            page: 1,
            total: 1
        }
    },
    created () {
        this.getRecords()
    },
    methods: {
        async getRecords () {
            let resData = await this.$axios.post('pc/Admin/getRoomStatePush',{
                start_time: Math.round(new Date(this.timelimits[0]).getTime() / 1000),
                end_time: Math.round((new Date(this.timelimits[1]).getTime() + 24 * 60 * 60 * 1000 - 1) / 1000),
                page: this.page,
                num: 10
            })
            if (resData.code === '00000' || resData.code === '99999') {
                this.list = resData.data
                this.total = resData.count
            }
        },
        push (name, status, id) {
            if (status == '0') {
                if (id.length >= 3) {
                    sessionStorage.setItem('settime',id)
                    this.$router.push({name: 'MatchList', query: {name: name, status: status, time: 'session'}})
                } else {
                    this.$router.push({name: 'MatchList', query: {name: name, status: status, id: id}})
                }
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.list-head{
    padding: 0;
    border-bottom: 0
}
p {
    height: 50px;
    line-height: 50px
}
ul{
    li{
        list-style: none;
        line-height: 30px;
        border-bottom: 1px solid #eee
    }
}
</style>
